import React from "react";
import { Tooltip } from "Components/Base/DataDisplay/Tooltip";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { removehtml } from "lib/format";
import { STYLE_LIST_ITEM_DESCRIPTION } from "./style";

/**
 * A component that displays a description text with optional truncation and tooltip.
 * If the description length exceeds maxLength, it will be truncated with an ellipsis
 * and the full text will be shown in a tooltip on hover.
 *
 * @component
 * @param {string} props.description - The description text to display, may contain HTML
 * @param {number} [props.maxLength=100] - Maximum length before truncating the text
 * @returns {JSX.Element} A text component with optional tooltip for long descriptions
 */

const Description = ({ description, maxLength = 100 }) => {
  const showTooltip = description.length > maxLength;
  const strippedText = removehtml(description);
  const truncatedText =
    strippedText.length > maxLength
      ? `${strippedText.substring(0, maxLength)}...`
      : strippedText;

  return showTooltip ? (
    <Tooltip title={strippedText} placement="top">
      <span className="break-anywhere">{truncatedText}</span>
    </Tooltip>
  ) : (
    <Typography
      variant="body2"
      className="break-anywhere"
      sx={STYLE_LIST_ITEM_DESCRIPTION}
    >
      {strippedText}
    </Typography>
  );
};

export default Description;
